import React, { useEffect, useState } from "react";
import {
  VerticalBarSeries,
  XAxis,
  YAxis,
  FlexibleWidthXYPlot,
  HorizontalGridLines,
  GradientDefs,
  Hint,
} from "react-vis";
import { getProceduresReferencedBy } from "services/Dashboard";

export const ProceduresReferencedBy = () => {
  const [procedures, setProcedures] = useState([]);
  const [hoveredPoint, setHoveredPoint] = useState(null);

  // Función para truncar texto
  const truncateText = (text, maxLength = 15) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  useEffect(() => {
    (async () => {
      const { data } = await getProceduresReferencedBy();
      // Filtrar elementos que no tengan el campo 'partner'
      const filteredData = data.filter(procedure => procedure.partner);
      const procedureItems = filteredData.map((procedure) => {
        return {
          x: `${procedure.partner}`,
          y: procedure.count,
          fullName: procedure.partner, // Guardamos el nombre completo para el tooltip
        };
      });
      setProcedures(procedureItems.sort((a, b) => a?._id - b?._id));
    })();
  }, []);

  return (
    <div>
      <FlexibleWidthXYPlot xType="ordinal" stackBy="y" height={350} margin={{bottom: 80}}>
        <GradientDefs>
          <linearGradient id="metric-gradient" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#3bbec8" stopOpacity={0.9} />
            <stop offset="100%" stopColor="#66d7d1" stopOpacity={0.9} />
          </linearGradient>
        </GradientDefs>
        <HorizontalGridLines style={{ strokeWidth: 1, stroke: "#66d7d140" }} />
        <XAxis
          tickFormat={(value, i) => {
            return truncateText(value);
          }}
          style={{
            line: { stroke: "#ADDDE1" },
            ticks: { stroke: "#ADDDE1" },
            text: { 
              stroke: "none", 
              fill: "#6b6b76", 
              fontWeight: 600,
              transform: "rotate(-45deg)",
              textAnchor: "end"
            }
          }}
        />
        <YAxis
          tickFormat={(value, i) => {
            return value;
          }}
          style={{
            line: { stroke: "#ADDDE1" },
            ticks: { stroke: "#ADDDE1" },
            text: { stroke: "none", fill: "#6b6b76", fontWeight: 600 }
          }}
        />

        <VerticalBarSeries
          barWidth={0.7}
          data={procedures}
          color={"url(#metric-gradient)"}
          onValueMouseOver={(datapoint, event) => {
            setHoveredPoint(datapoint);
          }}
          onValueMouseOut={() => {
            setHoveredPoint(null);
          }}
        />

        {/* Tooltip */}
        {hoveredPoint && (
          <Hint value={hoveredPoint}>
            <div style={{
              background: 'rgba(0, 0, 0, 0.8)',
              padding: '8px 12px',
              borderRadius: '4px',
              color: 'white',
              fontSize: '12px',
              maxWidth: '200px',
              wordWrap: 'break-word'
            }}>
              <div style={{ color: 'white' }}><strong>{hoveredPoint.fullName}</strong></div>
              <div style={{ color: 'white' }}>Procedimientos: {hoveredPoint.y}</div>
            </div>
          </Hint>
        )}
      </FlexibleWidthXYPlot>
    </div>
  );
};
